module.exports = __webpack_public_path__ + "static/media/nboost.47377765.svg";